import { render, staticRenderFns } from "./ModuleChooserModal.vue?vue&type=template&id=789c91da"
import script from "./ModuleChooserModal.vue?vue&type=script&lang=js"
export * from "./ModuleChooserModal.vue?vue&type=script&lang=js"
import style0 from "./ModuleChooserModal.vue?vue&type=style&index=0&id=789c91da&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports